import type { AppConfiguration, Translations } from '~/models';
import { DEFAULT_CONFIG, DEFAULT_TRANSLATIONS } from '~/models';

const getBoolConfig = (configValue?: string) => /^true$/i.test(configValue ?? '');

export const getConfiguration = (element: HTMLElement): AppConfiguration => {
  if ('config' in element.dataset) {
    const { config } = element.dataset;
    const parsedConfiguration = (config ? JSON.parse(config) : {}) as AppConfiguration;

    return {
      ...DEFAULT_CONFIG,
      ...parsedConfiguration,
      translations: { ...DEFAULT_TRANSLATIONS, ...parsedConfiguration.translations },
    };
  }

  const translations = {
    ...DEFAULT_TRANSLATIONS,
    ...(JSON.parse(element.dataset.translations ?? '{}') as Translations),
  };

  const {
    goToBasketUrl = DEFAULT_CONFIG.goToBasketUrl,
    isBasketSharingEnabled,
    staticApiUrl = DEFAULT_CONFIG.staticApiUrl,
    tenant = DEFAULT_CONFIG.tenant,
  } = element.dataset;

  return {
    goToBasketUrl,
    isBasketSharingEnabled:
      typeof isBasketSharingEnabled === 'string'
        ? getBoolConfig(isBasketSharingEnabled)
        : undefined,
    staticApiUrl,
    tenant,
    translations,
  };
};
